/**
 * @Desription: alert弹出提示
 * @Author: netstar.sjj
 * @Date: 2021-10-18 11:05:00
 * @class NSAlert
*/
declare const window:any;//window
namespace NSAlert{
    export function init(str:string,stateStr?:string,iconStr?:string,timer?:number){
        str = typeof(str)=='string' ? str : '';
        let language:any = window.language;
        let icon:string = '';
        let state:string = '';
        
        //计算默认值
        if(str.indexOf(language.common.nsalert.success)>-1||str.indexOf(language.common.nsalert.complete)>-1){
            icon = '<i class="fa fa-check"></i> ';
            state = 'success';
        }else if(str.indexOf(language.common.nsalert.fail)>-1||str.indexOf(language.common.nsalert.error)>-1||str.indexOf("error")>-1||str.indexOf(language.common.nsalert.deyk)>-1){
            icon = '<i class="fa fa-warning"></i> ';
            state = 'error';
        }else if(str.indexOf(language.common.nsalert.remind)>-1||str.indexOf(language.common.nsalert.warning)>-1||str.indexOf(language.common.nsalert.prompt)>-1||str.indexOf(language.common.nsalert.unable)>-1||str.indexOf(language.common.nsalert.prohibit)>-1){
            icon = '<i class="fa fa-warning"></i> ';
            state = 'warning';
        }
        //有iconStr参数
        if(typeof(iconStr) != 'undefined'){
            icon = '<i class="fa fa-'+iconStr+'"></i> ';
        }
        //有stateStr参数
        if(typeof(stateStr) != 'undefined'){
            state = stateStr;
        }
        if(state==''){
            state = 'info';
        }

        let tempTimer:number = 2000;
        if(icon==''){
            if(state == "error"||state == "warning"){
                icon = '<i class="fa fa-warning"></i> ';
                tempTimer = 5000;
            }else if(state == "success"){
                icon = '<i class="fa fa-check"></i> ';
            }else if(state == "info"){
                icon = '<i class="fa fa-comment"></i> ';
            }
        }
        let alertStr:string = icon+str;
        if(timer){
            tempTimer = timer;
        }
        window.toastr.options.timeOut = tempTimer;
        window.toastr.options.extendedTimeOut = 1000;

        switch(state){
            case "success":
                window.toastr.success(alertStr);
                break;
            case "info":
                window.toastr.info(alertStr);
                break;
            case "warning":
                window.toastr.warning(alertStr);
                break;
            case "error":
                window.toastr.error(alertStr);
                break;
        }
    }
}
export default NSAlert;